import { useForm, Controller } from "react-hook-form";
import { useState } from "react";

import Form from "../../../shared/components/Form";
import { ExtraInfoDropdownItem } from "../../../shared/components/Dropdown";
import { AsyncSelectSearch } from "../../../shared/components/SelectSearch";
import { getProductCategories } from "../../../../../services/Production/productClient";
import ImageUpload from "../../../shared/components/ImageUpload";

import { getUnitsOfMeasurement } from "../../../../../services/Production/unitsOfMesurementClient";

export default function ProductForm({ defaultValues, formId, onSubmit }) {
  const {
    register,
    formState: { errors },
    control,
    handleSubmit,
    setValue,
  } = useForm({ defaultValues });

  const [selectedImage, setSelectedImage] = useState(null);

  const handleSelectImage = (file) => {
    setValue("image", file);
    setSelectedImage(file);
  };

  return (
    <div style={{ display: "flex", width: "100%", gap: 10 }}>
      <ImageUpload
        file={selectedImage}
        onChange={handleSelectImage}
        fileTypes={["JPEG", "PNG", "GIF", "webp", "JPG"]}
      />

      <Form
        id={formId}
        onSubmit={handleSubmit(onSubmit)}
        style={{
          width: "calc(100% - 150px)",
          marginLeft: "auto",
          padding: "0 10px",
        }}
      >
        <Form.Group>
          <label htmlFor="name">Nom </label>
          <Form.Input {...register("name")} />
        </Form.Group>
        <Form.Group>
          <label htmlFor="name">Code</label>
          <Form.Input {...register("productCode")} />
        </Form.Group>
        <Form.Group>
          <label htmlFor="">Unité de mesure par défaut</label>
          <Controller
            name="defaultUnitOfMeasure"
            control={control}
            render={({ field, formState: { errors } }) => (
              <AsyncSelectSearch
                field={field}
                isInvalid={errors?.defaultUnitOfMesure}
                loaderFn={getUnitsOfMeasurement}
                getSelectValue={(option) => option.code}
                renderItem={(option) => (
                  <ExtraInfoDropdownItem
                    key={option.id}
                    option={{ main: option.code, info: option.name }}
                  />
                )}
              />
            )}
          />
        </Form.Group>
        <Form.Group>
          <label htmlFor="#">Catégorie</label>
          <Controller
            rules={{ required: true }}
            name="category"
            control={control}
            render={({ field, formState: { errors } }) => (
              <AsyncSelectSearch
                isInvalid={errors?.category}
                field={field}
                loaderFn={getProductCategories}
                resourceName={"ProductCategories"}
                getSelectValue={(option) => option.category}
                renderItem={(option) => (
                  <ExtraInfoDropdownItem
                    key={option.id}
                    option={{ main: option.category, info: option.category }}
                  />
                )}
              />
            )}
          />
        </Form.Group>
      </Form>
    </div>
  );
}
